export const AppInitConfig = Object.freeze({
  publicAuthRoute: '/auth/login',
  trazabilityCode: 'trazabilityCode',
  fwdUrl: 'fwdUrl',
  locale: 'es',
  initialize: 'initialize',
  loginState: 'loginState',
  expiryMinutes: 7,
});
